import type { GhlPrefillDto } from '../dto/gohighlevel.dto.js'

/**
 * A couple's leads, read into what a new event takes from them: the newest
 * opportunity first, and up to two more filling only what it lacked. The form
 * and an assistant booking from a lead both read them this way
 * (docs/gohighlevel.spec.md).
 */
export const PREFILL_READS = 3

/** `into`, with each detail it lacks taken from `from`. Nothing `into` has is replaced. */
export function fillPrefillGaps(into: GhlPrefillDto, from: GhlPrefillDto): GhlPrefillDto {
  return {
    first: into.first ?? from.first,
    last: into.last ?? from.last,
    partnerFirst: into.partnerFirst ?? from.partnerFirst,
    partnerLast: into.partnerLast ?? from.partnerLast,
    clientName: into.clientName ?? from.clientName,
    clientEmail: into.clientEmail ?? from.clientEmail,
    clientPhone: into.clientPhone ?? from.clientPhone,
    guestCount: into.guestCount ?? from.guestCount,
    notes: into.notes ?? from.notes,
    trackId: into.trackId ?? from.trackId,
  }
}

/** Whether anything is still missing, so another of the couple's leads is worth reading. */
export function prefillHasGaps(prefill: GhlPrefillDto): boolean {
  return Object.values(prefill).some((v) => v === null)
}
